import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UsersComponent } from './users.component';
import { AdminComponent } from './admin.component';
import { UserAddComponent } from './user.add.component'
import { CustomersComponent } from './customers.component';
import { CustomerAddComponent } from './customer.add.component';
import { CustomerDetailComponent } from './customer.detail.component';
import { CommentComponent } from './comments.component';
import { NotificationsComponent } from './notificiations.component';
import { ActivitiesComponent } from './activities.component';
import { CoreService } from '../core/core.service';

const routes: Routes = [
  CoreService.childRoutes([
    { path: 'users', component: UsersComponent, data: { title: 'Users' } },
    { path: 'admins', component: AdminComponent, data: { title: 'Admins' } },
    { path: 'useradd', component: UserAddComponent, data: { title: 'Add User' } },
    { path: 'comments', component: CommentComponent, data: { title: 'Comments' } },
    { path: 'customeradd', component: CustomerAddComponent, data: { title: 'Add Customer' } },
    { path: 'customer/:id', component: CustomerDetailComponent, data: { title: 'Customer Profile' } },
    { path: 'customers', component: CustomersComponent, data: { title: 'Customers' } },
    { path: 'notifications', component: NotificationsComponent, data: { title: 'Notifications' } },
    { path: 'activities', component: ActivitiesComponent, data: { title: 'Activities' } },
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AdminRoutingModule { }
